import {BigNumber, ethers} from "ethers";

const truncateRegex = /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/;

export const formatBigInt = (
  value: bigint,
  underlyingDecimals: bigint,
  dp = 2
) => {
  const valueNumber = +value.toString() / 10 ** +underlyingDecimals.toString()
  const [decimalPart, fractionalPart = '00'] = valueNumber.toString().split('.')
  return `${decimalPart}.${fractionalPart.slice(0, dp)}`
}

export const truncateEthAddress = (address: string | `0x${string}`) => {
  const match = address.match(truncateRegex);
  if (!match) return address;
  return `${match[1]}…${match[2]}`;
};

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const MAX_DECIMALS = 4

export function fromReadableAmount(
  amount: number,
  decimals: number
): BigNumber {
  return ethers.utils.parseUnits(amount.toString(), decimals)
}

export function toReadableAmount(rawAmount: number, decimals: number): string {
  return ethers.utils.formatUnits(rawAmount, decimals).slice(0, MAX_DECIMALS)
}

export default function isZero(hexNumberString: string) {
  return /^0x0*$/.test(hexNumberString)
}

export const numberToHex = (value: number): string => {
  return '0x' + value.toString(16);
};
